<template>
    <div class="coach-admin-master-list">
        <div class="coach-admin-master-list-wrapper">
            <CoachAdminCard v-for="coachAdmin in coachAdmins" :key="coachAdmin.id" :coach-admin="coachAdmin" />
        </div>
    </div>
</template>

<script>
import CoachAdminCard from '@components/CoachAdminMaster/CoachAdminCard'

export default {
    components: {
        CoachAdminCard
    },
    props: {
        coachAdmins: {
            type: Array,
            required: true
        }
    }
}
</script>
